import { PortableText } from '@portabletext/react'
import { styled } from '@aether/styles'
import type { PortableTextBlock } from '@sanity/types'

const Text = styled('section', {
  $aetherFont: 'heading05',

  '@md': {
    $aetherFont: 'heading04',
    maxWidth: '995px',
  },
})

interface MainCopyProps {
  content: PortableTextBlock
}

export const MainCopy = ({ content }: MainCopyProps) => {
  if (!content) return null

  return (
    <Text>
      <PortableText value={content} />
    </Text>
  )
}
